import Collection from '../collection';
import Config from '../config';
import Form from './form';

import { hashify } from '../utils/arrays';
import { pick } from '../utils/popups';





export default Form.extend( {

    bindingHandlers: {

        defaultPossibleValues: {
            set($el, value) {
                const { selected, options } = value;
                $el.html( ([ '' ].concat( options || [] ))
                    .map( s => `<option>${s}</option>` ) );
                $el.val( selected );
            },
            
            get($el, value, event) {
                return $el.val();
            }
        },

    },

    onBind(field) {
        this.listenTo( field, 'change:format',
            () => {
                const format = field.get( 'format' );
                field.set( 'device_gallery_enabled_by_default', 
                    format == 'file' ? 't' : null );
                field.set( 'device_gallery_enabled_inverted_for_roles', 
                    format == 'file' ? [] : null );
            } );
    },

    onUnBind(prevField) {
        this.stopListening( prevField );
    },

    [Form.event( 'editable:manage-roles' )]() {
        manageRoles( this.model,
            this.options,
            'editable_by_default', 'editable_inverted_for_roles' );
    },

    [Form.event( 'device_gallery_enabled:manage-roles' )]() {
        manageRoles( this.model,
            this.options,
            'device_gallery_enabled_by_default', 'device_gallery_enabled_inverted_for_roles' );
    },

} );





function manageRoles(field, { roles, clusters: clustersColl, }, byDefaultProp, invertedRolesProp) {
    roles = roles.toJSON();

    const byDefaultValue = [true, 't'].includes( field.get( byDefaultProp ) );
    const inverted = hashify( field.get( invertedRolesProp ), id => [+id, true] );
    // вычислим роли, которые в модалке должны быть помечены как "видимые"
    const selected = roles.filter( role => byDefaultValue ^ inverted[role.id] );
    // вычислим роли, которые можно перещёлкивать
    const manageableRoles = new Collection( roles
        .filter( role => 
            // с глобальным уровнем можно всё
            Config.level() === 'GLOBAL' ||
            // с локальным полем можно подключать любые роли
            field.get( 'cluster' ) != null ||
            // ну или у меня есть доступ к кластеру роли
            role.cluster != null && Config.clusters().find( cluster => cluster.id == role.cluster.id ) )
        // заодно осуществим фильтрацию по кластеру поля и роли
        // (хотя она и задублируется по сравнению с pickmodal),
        // потому что без неё не сработает правильно инвертирование в then ниже
        .filter( role =>
            // глобальная роль совместима с любым полем
            role.cluster == null ||
            // глобальное поле совместимо с любой ролью
            field.get( 'cluster' ) == null || 
            // роли и поля из одного кластера совместимы
            role.cluster.id == field.get( 'cluster' ).id ) );

    pick( selected, {
        collection: manageableRoles,
        cluster: field.get( 'cluster' ),
        clusters: clustersColl,
        idOnly: true,
        fullCollection: true,
    } ).then( sel => {
        // по умолчанию выключено - значит sel отражает те роли, которые лежат в inverted
        if (!byDefaultValue)
            return field.set( invertedRolesProp, sel );

        // по умолчанию включено - значит sel отражает те роли, которых в inverted
        // не должно быть и надо его инвертировать

        const manageable = hashify( manageableRoles.models.map( role => role.id ) );
        // ту часть inverted, к ролям которой нет доступа, оставляем неизменной
        const base = Object.keys( inverted )
            .map( id => +id )
            .filter( id => !manageable[id] );
        // роли, к которым есть доступ, инвертируются на основе переданного sel
        const variable = roles
            .map( role => +role.id )
            .filter( id => manageable[id] )
            .filter( id => !sel.includes( id ) );
        // и объединяем
        const newInverted = [...base, ...variable];

        field.set( invertedRolesProp, newInverted );
    } );
}


// WEBPACK FOOTER //
// ./src/js/view/field.fields.js